import { RegionTypes, StatesRegionTypes } from 'store/modules/online_search_store/types';

export const Regions: Array<RegionTypes> = [
  { label: 'Centro-Oeste', value: 'centro_oeste' },
  { label: 'Nordeste', value: 'nordeste' },
  { label: 'Norte', value: 'norte' },
  { label: 'Sudeste', value: 'sudeste' },
  { label: 'Sul', value: 'sul' },
];

export const RegionsStates: StatesRegionTypes = {
  centro_oeste: [
    { label: 'Distrito Federal', value: 7, uf: 'DF' },
    { label: 'Goiás', value: 9, uf: 'GO' },
    { label: 'Mato Grosso do Sul', value: 12, uf: 'MS' },
    { label: 'Mato Grosso', value: 13, uf: 'MT' },
  ],
  nordeste: [
    { label: 'Alagoas', value: 2, uf: 'AL' },
    { label: 'Bahia', value: 5, uf: 'BA' },
    { label: 'Ceará', value: 6, uf: 'CE' },
    { label: 'Maranhão', value: 10, uf: 'MA' },
    { label: 'Paraíba', value: 15, uf: 'PB' },
    { label: 'Pernambuco', value: 16, uf: 'PE' },
    { label: 'Piauí', value: 17, uf: 'PI' },
    { label: 'Rio Grande do Norte', value: 20, uf: 'RN' },
    { label: 'Sergipe', value: 25, uf: 'SE' },
  ],
  norte: [
    { label: 'Acre', value: 1, uf: 'AC' },
    { label: 'Amazonas', value: 3, uf: 'AM' },
    { label: 'Amapá', value: 4, uf: 'AP' },
    { label: 'Pará', value: 14, uf: 'PA' },
    { label: 'Rondônia', value: 21, uf: 'RO' },
    { label: 'Roraima', value: 22, uf: 'RR' },
    { label: 'Tocantins', value: 27, uf: 'TO' },
  ],
  sudeste: [
    { label: 'Espírito Santo', value: 8, uf: 'ES' },
    { label: 'Minas Gerais', value: 11, uf: 'MG' },
    { label: 'Rio de Janeiro', value: 19, uf: 'RJ' },
    { label: 'São Paulo', value: 26, uf: 'SP' },
  ],
  sul: [
    { label: 'Paraná', value: 18, uf: 'PR' },
    { label: 'Rio Grande do Sul', value: 23, uf: 'RS' },
    { label: 'Santa Catarina', value: 24, uf: 'SC' },
  ],
};

export const AllStatesInitials: Array<string> = Object.values(RegionsStates).flatMap((states) =>
  states.map((state) => state.uf),
);
